//vemaChecker v2.2.3
! function(t) {
  let checker = function(t){
    let text = t.data.text;
    for (const [key, value] of Object.entries(t.data)) {
      switch (key) {
        case 'noSpaces':
          if(!text.replace(/\s/g, '').length)return false;
          break;
        case 'min':
          if(text.length==0 && t.data.optional)return true;
          if(text.length<t.data.min || text.length>t.data.max)return false;
          if(t.data.noSpecial)return !/[+,:;=?[\]|{}<>^]/u.test(text);
          if(t.data.pattern)return (t.data.optional && text.length==0) ? true : t.data.pattern.test(text);
          return true;
          break;
        case 'pattern':
          return (t.data.optional && text.length==0) ? true : value.test(text);
          break;
        case 'noSpecial':
          if(value)return /[+,:;=?[\]|{}<>^]/u.test(text);
          break;
        case 'email':
          return (t.data.optional && text.length==0) ? true : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(text);
          break;
        case 'price':
          if(value && /^-?\d*(\.\d+)?$/.test(text)){
            if(parseInt(text) < t.data.low)return false;
            return true;
          } else return false;
          break;
        case 'integer':
          if(text.length>11)return false;
          if(value)return /^\d+$/.test(text);
          break;
        default:
          return true;
      }
    }
  }
  t.vemaChecker = function(t) {
    if(function(t) {
      return void 0 !== t.data && void 0 !== t.data.text
    }(t))return {check: checker(t), message: t.data.message}
    if (app.params.type === 'dev')console.log("Bad params.")
  }
}(window);
